import { useEffect, useState } from "react";
import { loadCostExpenseCategories } from "../services/costingService";

const useGetExpenseCategories = (id_costing_expenses) => {
  const [expenseCategories, setExpensesCategories] = useState([]);
  const [isDataLoad, setIsDataLoad] = useState(false);

  useEffect(() => {
    const fetchExpenseCategories = async () => {
      if (!isDataLoad) {
        try {
          const payload = {
            p_companyid: localStorage.getItem("companyid") || 0,
            p_plantid: 1,
            p_id_costing_expenses: id_costing_expenses,
          };

          const data = await loadCostExpenseCategories(payload);
          if (data?.length > 0) {
            setExpensesCategories(data);
          }
        } catch (error) {
          console.error("Error loading expense categories:", error);
        } finally {
          setIsDataLoad(true);
        }
      }
    };

    fetchExpenseCategories();
  }, [id_costing_expenses, isDataLoad]);

  return {
    expenseCategories,
    setExpensesCategories,
  };
};

export default useGetExpenseCategories;
